import {LIBROS_TYPES} from '../constants/libros.types'
import {Libros, LibrosAction, LibrosState} from '../interfaces/libros.interface'

const initialState: LibrosState = {
  formVentas: {},
  formConsultaVentas: {},
  formConsultaLibros: {},
  dataConsultaVentas: [],
  dataConsultaLibros: [],
  tableVentasTotalPages: 0,
  tableVentasPageActual: 0,
  ventasModalFormatos: false,
  ventasModalCargaFormato: false,
  ventasRetencionesDetectadas: [],
  ventasIncluirRetenciones: false,

  comprasLibroActivo: {},
  comprasFormCargarLibro: {},
  comprasDataLibros: [],
  comprasFileDataCargada: {},

  responseJSONHacienda: [],
}

const librosReducer = (
  state: Libros = initialState,
  action: LibrosAction
): LibrosState => {
  switch (action.type) {
    case LIBROS_TYPES.LIBRO_CHANGE_FORM_VENTAS:
      return {...state, formVentas: action.payload}
    case LIBROS_TYPES.LIBRO_CHANGE_FORM_CONSULTA_VENTAS:
      return {...state, formConsultaVentas: action.payload}
    case LIBROS_TYPES.LIBRO_CHANGE_FORM_CONSULTA_LIBROS:
      return {...state, formConsultaLibros: action.payload}
    case LIBROS_TYPES.LIBRO_SET_DATA_CONSULTA_VENTAS:
      return {...state, dataConsultaVentas: action.payload}
    case LIBROS_TYPES.LIBRO_VENTAS_SET_TABLE_PAGINAS:
      return {...state, tableVentasTotalPages: action.payload}
    case LIBROS_TYPES.LIBRO_VENTAS_SET_TABLE_PAGINA_ACTUAL:
      return {...state, tableVentasPageActual: action.payload}
    case LIBROS_TYPES.LIBRO_HISTORIAL_VENTAS_SET_CONSULTA_LIBROS:
      return {...state, dataConsultaLibros: action.payload}
    case LIBROS_TYPES.VENTAS_MODAL_FORMATOS_DESCARGAS:
      return {...state, ventasModalFormatos: action.payload}
    case LIBROS_TYPES.VENTAS_MODAL_CARGAR_FORMATOS:
      return {...state, ventasModalCargaFormato: action.payload}
    case LIBROS_TYPES.VENTAS_SET_RETENCIONES_DETECTADAS:
      return {...state, ventasRetencionesDetectadas: action.payload, ventasIncluirRetenciones: false}
    case LIBROS_TYPES.VENTAS_SET_INCLUIR_RETENCIONES:
      return {...state, ventasIncluirRetenciones: action.payload}

    case LIBROS_TYPES.COMPRAS_CHANGE_FORM_CARGA:
      return {...state, comprasFormCargarLibro: action.payload}
    case LIBROS_TYPES.COMPRAS_SET_FILE_DATA_CARGADA:
      return {...state, comprasFileDataCargada: action.payload}
    case LIBROS_TYPES.COMPRAS_SET_LIBRO_ACTIVO:
      return {...state, comprasLibroActivo: action.payload}
    case LIBROS_TYPES.COMPRAS_SET_DATA_LIBROS:
      return {...state, comprasDataLibros: action.payload}
    
    case LIBROS_TYPES.JSON_RESPONSE_HACIENDA_DTE:
      return {...state, responseJSONHacienda: action.payload}

    case LIBROS_TYPES.LIBROS_CLEAR_MODULE:
      return { ...initialState }
    default:
      return state
  }
}

export default librosReducer
